
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 48","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 24.5V16H17.5c-.831 0-1.5.669-1.5 1.5v29c0 .831.669 1.5 1.5 1.5h21c.831 0 1.5-.669 1.5-1.5V26h-8.5c-.825 0-1.5-.675-1.5-1.5zm4 14.75c0 .413-.337.75-.75.75h-10.5a.752.752 0 01-.75-.75v-.5c0-.413.337-.75.75-.75h10.5c.413 0 .75.337.75.75v.5zm0-4c0 .413-.337.75-.75.75h-10.5a.752.752 0 01-.75-.75v-.5c0-.413.337-.75.75-.75h10.5c.413 0 .75.337.75.75v.5zm0-4.5v.5c0 .413-.337.75-.75.75h-10.5a.752.752 0 01-.75-.75v-.5c0-.413.337-.75.75-.75h10.5c.413 0 .75.337.75.75zm6-7.131V24h-8v-8h.381c.4 0 .782.156 1.063.438l6.118 6.125c.282.28.438.662.438 1.056z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14 40V15.5c0-.831.669-1.5 1.5-1.5H22V8H9.5C8.669 8 8 8.669 8 9.5v29c0 .831.669 1.5 1.5 1.5H14zM31.363 14.363l-5.92-5.925A1.498 1.498 0 0024.381 8H24v6h6.38c.364 0 .712.129.983.363z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6 32V7.5C6 6.669 6.669 6 7.5 6H14V0H1.5C.669 0 0 .669 0 1.5v29c0 .831.669 1.5 1.5 1.5H6zM23.361 6.36L17.444.438A1.5 1.5 0 0016.38 0H16v6h6.381a1.5 1.5 0 01.98.36z","fill":"currentColor"}})])
          )
        }
      }
    